import {get_token} from "@/router";
import Swal from 'sweetalert2';

export default {
  computed: {
    filteredEvents() {
      return this.showAll ? this.upcoming_events : this.upcoming_events.slice(0, this.visibleCount);
    }
  }
,  
  mounted() {
    this.token_exists = get_token();
    const selectedEvent = JSON.parse(sessionStorage.getItem('selectedEvent'));
    const selectedExtras = JSON.parse(sessionStorage.getItem('selectedExtras')) || [];
    const selectedExtraItems = JSON.parse(sessionStorage.getItem('selectedExtraItems')) || [];
    const selectedItemId = JSON.parse(sessionStorage.getItem('selectedItemId')) || [];
    const businessName = JSON.parse(sessionStorage.getItem('businessName')) || '';
    const isFirstTime = JSON.parse(sessionStorage.getItem('isFirstTime')) || false;
    const chapter = JSON.parse(sessionStorage.getItem('chapter')) || '';



    const nextUrl = sessionStorage.getItem('next');

    if (nextUrl && this.token_exists) {

        this.selectedEvent = selectedEvent;
        this.selectedExtraId = selectedExtras;
        this.selectedExtraItemId = selectedExtraItems;
        this.selectedItemId = selectedItemId
        this.businessName = businessName;
        this.isFirstTime = isFirstTime;
        this.chapter = chapter;
        if (typeof this.addRsvp === 'function') {
          this.addRsvp()
          sessionStorage.removeItem('next');
          sessionStorage.removeItem('selectedEvent');
          sessionStorage.removeItem('selectedExtras');
          sessionStorage.removeItem('selectedExtraItems');
          sessionStorage.removeItem('selectedItemId')
          sessionStorage.removeItem('businessName');
          sessionStorage.removeItem('isFirstTime');
          sessionStorage.removeItem('chapter');
      }
    }
    this.fetch_user_events();
    this.fetchExtras();

  },

  data() {
    return ({
    user_events :[],
    upcoming_events :[],
    showAll: false, 
    visibleCount: 4,
    token_exists: false,
    selectedEvent: {},
    eventExtras: [],
    extraItems: [],
    selectedExtraId: [],
    selectedExtraItemId: [],
    selectedItemId: [],
    businessName: '',
    isFirstTime: false,
    chapter: '',
    });
  },

  methods: {

    getToken() {
        return get_token();
      },
    toggleShowMore() {
      this.showAll = !this.showAll; // Toggle between showing all and limiting to visibleCount
    },
    formatMonth(dateStr) {
      const date = new Date(dateStr);
      return date.toLocaleString('default', { month: 'short' }).toUpperCase(); // e.g., "FEB"
    },
    formatDay(dateStr) {
      const date = new Date(dateStr);
      return date.getDate(); // e.g., 2
    },
    formatDate(dateStr) {
      const date = new Date(dateStr);
      const day = date.getDate();
      const suffix = (d => {
        if (d > 3 && d < 21) return 'th';
        switch (d % 10) {
          case 1: return 'st';
          case 2: return 'nd';
          case 3: return 'rd';
          default: return 'th';
        }
      })(day);

      const weekday = date.toLocaleDateString('en-US', { weekday: 'long' });
      return `${weekday} ${day}${suffix}`;
    },
     form_time(timeString) {
      if (!timeString) return "";
      const [hour, minute] = timeString.split(":");
      const date = new Date();
      date.setHours(hour, minute);
      return date.toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });
    },
    clearForm() {
      this.item_name = '';
      this.item_description = '';
      this.item_price = '';
      this.extraItems = [];
      this.event_name = '';
      this.start_date = '';
      this.end_date = '';
      this.event_description = '';
      this.selectedPortalId = '';
      this.organizer = '';
      this.location = '';
      this.rsvp_start_date = '';
      this.rsvp_end_date = '';
      this.upload_media = null;
      this.selectedExtraText = '';
      this.event_type = '';
      if (this.$refs.quillEventEditorRef) {
        this.$refs.quillEventEditorRef.setHTML('');

      };
      this.extraForms = [];
      this.show_add_extras=true


    },
    fetchExtras() {
      this.isLoading = true;
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_all_extra/`,
        method: 'GET',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        success: (data) => {
          this.extras = data.extras;
          setTimeout(() => {
            this.loading = false;
        }, 1000);
        },
        complete: () => {
          this.isLoading = false;
        }
      });
    },
    selectEvent(event) {
      this.selectedEvent = event;
    },
    fetchEvents_extras(event_id) {
      this.selectEvent.id = event_id;
      this.isLoading = true;
      this.token_exists = get_token();
      this.clearForm()
      this.selectedItemId=[]

      // Close the event modal before making the request
      $('#eventModal').modal('hide');

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_event_data/`,
        method: 'GET',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
        },
        data: { event_id: event_id },
        success: (response_data) => {
          this.eventExtras = response_data.event_extras;
          if (this.eventExtras && this.eventExtras.length > 0) {
            $('#rsvp_modal').modal('show'); // Open RSVP modal
          } else {
            this.addRsvp(); // Call addRsvp if no extra details
          }
        },
        complete: () => {
          this.isLoading = false;
        }
      });
    },
    addRsvp() {

          if(!this.token_exists){
            const nextUrl = this.$router.currentRoute.value.fullPath;
              if (nextUrl) {
                sessionStorage.setItem('next', nextUrl);
                sessionStorage.setItem('selectedEvent', JSON.stringify(this.selectedEvent));
                sessionStorage.setItem('selectedExtras', JSON.stringify(this.selectedExtraId));
                sessionStorage.setItem('selectedItemId',JSON.stringify(this.selectedItemId))
                sessionStorage.setItem('businessName', JSON.stringify(this.businessName));
                sessionStorage.setItem('isFirstTime', JSON.stringify(this.isFirstTime));
                sessionStorage.setItem('chapter', JSON.stringify(this.chapter));
              }
              window.location = '/sign_in_Finale';
              return;
          }
          this.isSubmitting = true;
          const formData = new FormData();
          formData.append('event_id', this.selectedEvent.id);
          if (Array.isArray(this.selectedItemId)) {
            this.selectedItemId.forEach(itemId => {
                formData.append('item_id[]', itemId);
            });
        } else {
            formData.append('item_id', this.selectedItemId);
        }
        formData.append('business_name', this.businessName || '');
        formData.append('is_first_time', this.isFirstTime ? 'True' : 'False');
        formData.append('chapter', this.chapter || '');
          $.ajax({
            type: "POST",
            url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/add_event_rsvp/`,
            data: formData,
            processData: false,
            contentType: false,
            headers: {
              'Authorization': `Token ${this.getToken()}`,
            },
            success: (response) => {
              const status = response.status;
              if (status === "success") {
                this.selectedEvent.is_rsvped = true;
                Swal.fire({
                  icon: 'success',
                  title: 'RSVP Successful',
                  showConfirmButton: false,
                  timer: 2000,
                }).then(() => {

                  Swal.close();
                  sessionStorage.removeItem('selectedEvent');
                  sessionStorage.removeItem('selectedExtras');
                  sessionStorage.removeItem('selectedItemId');
                  sessionStorage.removeItem('businessName');
                  sessionStorage.removeItem('isFirstTime');
                  sessionStorage.removeItem('chapter');

                  this.selectedEvent = {};
                  this.selectedExtraId = [];
                  this.businessName = '';
                  $('#rsvp_modal').modal('hide');
                });
              }
            },
            error: (response) => {
              Swal.close();
              const response_data = response.responseJSON;
              if (response_data.status === "error") {
                Swal.fire({
                  icon: 'info',
                  text: response_data.message,
                  showConfirmButton: false,
                  timer: 2000,

                }).then(() => {
                  Swal.close();
                  sessionStorage.removeItem('selectedEvent');
                  sessionStorage.removeItem('selectedExtras');
                  sessionStorage.removeItem('selectedItemId');
                  sessionStorage.removeItem('businessName');
                  sessionStorage.removeItem('isFirstTime');
                  sessionStorage.removeItem('chapter');


                  this.selectedEvent = {};
                  this.selectedExtraId = [];
                  this.selectedItemId=[];
                  this.businessName = '';

                  $('#rsvp_modal').modal('hide');
                });
              }
            }

          })
        },
    fetch_user_events(){

        var value = JSON.stringify({
          filter_values: {}
         })
        $.ajax({
            url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/filter_events_api/`,
            method: 'POST',
            headers: {
              'Authorization': `Token ${this.getToken()}`,
              'Content-Type': 'application/json'
            },
            data:value,
            success: (response) => {
              if (response.status === 'success') {
                this.user_events = response.data.events;

                const today = new Date().toISOString().slice(0, 10);

          this.upcoming_events = this.user_events.filter(event => event.end_date >= today);

          }
            },
          }); 
    },
    isWithinRSVPPeriod(event) {
      const now = new Date();
      const start = new Date(`${event.rsvp_start_date}T${event.rsvp_start_time}`);
      const end = new Date(`${event.rsvp_end_date}T${event.rsvp_end_time}`);
      if (now < start) {
        return ({ isValid: false, message: "RSVP has not started yet." });
      }
      if (now > end) {
        return ({ isValid: false, message: "RSVP period has ended." });
      }
      return ({ isValid: true, message: "" });
    },
    isEventStarted(event) {
      const now = new Date();
      // Combine date and time for start and end time
      const start = new Date(`${event.start_date}T${event.start_time}`);
      const end = new Date(`${event.end_date}T${event.end_time}`);

      var object={ canJoin: true, message: "" }
      // If the current time is before the event starts (checking both date and time)
      if (now < start) {
          object={ canJoin: false, message: "The event hasn't started yet." }
        return object;
      }
      // If the current time is after the event ends (checking both date and time)
      if (now > end) {
          object={ canJoin: false, message: "The event has ended." }
        return object;

      }
      return object;
    },
cancelRSVP(event_id) {
    const token = this.getToken();

    if (!Number.isInteger(event_id)) {
    Swal.fire('Invalid ID', 'The event ID is not valid.', 'error');
    return;
  }

  $.ajax({
    type: 'POST',
    url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/cancel_rsvp/`,
    contentType: 'application/json',
    data: JSON.stringify({ event_id: event_id }),
    headers: {
      'Authorization': `Token ${token}`
    },
    success: (data) => {
      if (data.status === 'success') {
          for (const event of this.user_events) {
          if (event.id === event_id) {
            event.is_rsvped = false;
            break;
          }
        }

        Swal.fire({
          icon: 'success',
          title: 'RSVP Cancelled',
          showConfirmButton: false,
          timer: 2000
        }).then(() => {
          $('#eventModal').modal('hide');
        })
      } else {
        Swal.fire('Error', data.message || 'Cancel failed', 'error');
      }
    },
    error: (xhr) => {
      const response = xhr.responseJSON || {};
      Swal.fire('Error', response.message || 'Something went wrong', 'error');
    }
  });
}
  },
};

